import { createSlice } from "@reduxjs/toolkit";
import { getLocale } from "../Services/CommonServices";
import { LOCALE } from "../Constants/CommonConstants";

const initialState = {
  value: getLocale(),
};

export const localeSlice = createSlice({
  name: "locale",
  initialState,
  reducers: {
    changeLocale: (state, action) => {
      const language = action.payload;
      localStorage.setItem(LOCALE, language);
      state.value = language;
    },
  },
});

export const { changeLocale } = localeSlice.actions;

export default localeSlice.reducer;
